import React, { useEffect, useState, Fragment } from "react";
import { Col, Container, Row } from "react-bs4grid";
import { Link } from "react-router-dom";

import AppContainer from "../AppContainer/AppContainer";
import axiosInstance from "../../apiPromises/axiosInstance";
import useAppState from "../../common/StateMachine/useAppState";
import Button from "../../common/Button/Button";

import "./profile.scss";

const QrCode = props => {
  const accountState = useAppState("account");
  const account = accountState.state;
  const [userProfile, setUserProfile] = useState({});

  useEffect(() => {
    axiosInstance.get("/users/current").then(res => {
      setUserProfile(res.data);
    });
  }, []);

  console.log(userProfile);
  return (
    <AppContainer>
      {account && userProfile.userId && (
        <Fragment>
          <Container className="mt-16">
            <Row
              className="pb-32 pt-32"
              justifyContent="center"
              alignItems="center"
            >
              <Col style={{ display: "flex", justifyContent: "center" }}>
                <div className="job-details-content">
                  <h1>Scan your QR code when you drop off</h1>
                </div>
              </Col>
            </Row>
          </Container>
          <Container fluid className="jobs-list-container">
            <Row
              className="jobs-list"
              justifyContent="center"
              alignItems="center"
            >
              <Col w="auto">
                <div className="profile-qr-code-section pt-32 pb-16">
                  <div className="profile-qr-code-wrapper">
                    <img src={userProfile.qrCodeImagePath} alt="icon profile" />
                  </div>
                </div>
              </Col>
            </Row>
            <Row
              className="jobs-list"
              justifyContent="center"
              alignItems="center"
            >
              <Col w="auto">
                <div className="pt-32 pb-16">
                  <div className="profile-credentials-section">
                    <img src="/icon-id.svg" alt="icon id" />
                    <div>
                      <h3>Authorised PlastX Collector ID:</h3>
                      <h4>{userProfile.fullName} {userProfile.userId}</h4>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="pb-128" justifyContent="center" alignItems="center">
              <Col w="auto">
                <Link to="/user/my-profile">
                  <Button
                    secondary
                    className="mt-32 mb-32"
                    text="Back to profile"
                  />
                </Link>
              </Col>
            </Row>
          </Container>
        </Fragment>
      )}
    </AppContainer>
  );
};

export default QrCode;
